export default __webpack_public_path__ + "static/media/stadium.d3f16976.jpg";